/**
 * @generated SignedSource<<4f3bac82f83e73ca95ad798f203e6d04>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateUserGameSettingsInput = {
  gameSlug: string;
  jsonString: string;
};
export type GamePlayUpdateMutationsUpdateGameSettingsMutation$variables = {
  input: UpdateUserGameSettingsInput;
};
export type GamePlayUpdateMutationsUpdateGameSettingsMutation$data = {
  readonly updateUserGameSettings: {
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"PlayGameSettingsSync" | "PuzzmoCurrentUserStateFragment">;
  };
};
export type GamePlayUpdateMutationsUpdateGameSettingsMutation = {
  response: GamePlayUpdateMutationsUpdateGameSettingsMutation$data;
  variables: GamePlayUpdateMutationsUpdateGameSettingsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "GamePlayUpdateMutationsUpdateGameSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserState",
        "kind": "LinkedField",
        "name": "updateUserGameSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PuzzmoCurrentUserStateFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PlayGameSettingsSync"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GamePlayUpdateMutationsUpdateGameSettingsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UserState",
        "kind": "LinkedField",
        "name": "updateUserGameSettings",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "ownerID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nakamaLogin",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nakamaPassword",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gameSettings",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5ed9843e96b03e226cd78cf98aa4b0c7",
    "id": null,
    "metadata": {},
    "name": "GamePlayUpdateMutationsUpdateGameSettingsMutation",
    "operationKind": "mutation",
    "text": "mutation GamePlayUpdateMutationsUpdateGameSettingsMutation(\n  $input: UpdateUserGameSettingsInput!\n) {\n  updateUserGameSettings(input: $input) {\n    id\n    ...PuzzmoCurrentUserStateFragment\n    ...PlayGameSettingsSync\n  }\n}\n\nfragment PlayGameSettingsSync on UserState {\n  gameSettings\n}\n\nfragment PuzzmoCurrentUserStateFragment on UserState {\n  id\n  ownerID\n  nakamaLogin\n  nakamaPassword\n  gameSettings\n}\n"
  }
};
})();

(node as any).hash = "182bf48f29fe894621aeffbf775de57b";

export default node;
